import type { IAuthRepository } from '@src/domain/users/repository';
import type { User } from '@src/domain/users/entities/user.entity';

/**
 * Get Current User Use Case
 * Retrieves the currently authenticated user
 */
export class GetCurrentUserUseCase {
    constructor(private readonly authRepository: IAuthRepository) { }

    async execute(): Promise<User> {
        return await this.authRepository.getCurrentUser();
    }
}
